import APIService from '@/services/APIService.js';

export default {
  getBdgdsImportadas(empresaId) {
    return APIService.apiCall().get(`/hexaMaps/getBdgdsImportadas/${empresaId}`);
  },
  getEntidadesBdgdsImportadas(data, empresaId, bdgdVersaoId) {
    return APIService.apiCall().get(`/hexaMaps/getEntidadesBdgdsImportadas/${empresaId}/${data}/${bdgdVersaoId}`);
  },
  getEntidadesBdgdsRelevantes() {
    return [
      'bar',
      'eqcr',
      'eqme',
      'eqre',
      'eqse',
      'eqtrat',
      'eqtrm',
      'eqtrmt',
      'ponnot',
      'ramlig',
      'ssdat',
      'ssdbt',
      'ssdmt',
      'segcon'
    ];
  },
  getEntidadesBdgdsAcessorias() {
    return [
      'uncrmt',
      'uncrbt',
      'uncrat',
      'ucbt',
      'ucmt',
      'ucat',
      'unremt',
      'unreat',
      'unsemt',
      'unsebt',
      'unseat',
      'untrat',
      'ugat',
      'ugmt',
      'ugbt',
      'untrmt'
    ];
  }
};
